(function($) {

  function initSlickSlider($slider, callback) {
    if (!$slider || !$slider.length) return;
  
    // Remove old slick
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
      $slider.removeClass('nb_has_slider');
    }
  
    var totalItems = $slider.find('.product_tab_col').length;
    var windowWidth = window.innerWidth;
    var slidesToShow = 4;
  
    if (windowWidth < 480 || windowWidth < 768) {
      slidesToShow = 2;
    } else if (windowWidth < 1024) {
      slidesToShow = 3;
    }
  
    if (totalItems >= slidesToShow) {
      $slider.on('init', function () {
        $slider.addClass('nb_has_slider');
        if (typeof callback === 'function') callback();
      });
  
      $slider.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3 } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 2 } }
        ]
      });
    } else {
      if (typeof callback === 'function') callback();
    }
  }



  $(document).ready(function() {

    // Search button toggle
    $('.search_button').click(function() {
      $('.predictive_search_grid').toggleClass('active_search');
    });

    
    var $firstSlider = $('.collection_tab_products.active_product_grid');
    // var $loader = $firstSlider.find('.slider-loader');
    var $loader = $('.collection_product_tab_wrapper .slider-loader');
    $loader.show();
    $firstSlider.hide();
  
    setTimeout(function () {
      initSlickSlider($firstSlider, function () {
        $loader.fadeOut(350);
        $firstSlider.fadeIn(300);
      });
    }, 50);
    
    // $('.collection_tabs .collection_tab:first-child').trigger('click');

    // Tab click handler
    $('.collection_tab').click(function () {
      $('.collection_tab').removeClass('active_heading');
      $('.collection_tab_products').removeClass('active_product_grid');
    
      $(this).addClass('active_heading');
      var selected_label = $(this).attr('data-tab').toLowerCase();
      var $targetTab = $('.collection_tab_products[data-label="' + selected_label + '"]');
      // var $loader = $targetTab.find('.slider-loader');
    
      $loader.show();
      // $targetTab.hide();
      $('.collection_tab_products').hide();
    
      setTimeout(function () {
        initSlickSlider($targetTab, function () {
          $('.collection_tab_products').removeClass('active_product_grid'); // just in case
          $targetTab.addClass('active_product_grid');
          $loader.fadeOut(350);
          $targetTab.fadeIn(300);
        });
      }, 50);
    });

    // Variant image change
    /* $(document).on('click', '.product_tab_variants label', function() {
      var selected_image = $(this).attr('variant-src');
      var variantUrl = $(this).attr('data-variant');
      $(this).closest('.product_tab_columns').find('.product_tab_image img').attr('src', selected_image);
      $('.product_tab_image a').attr('href', variantUrl);
      $('.product_tab_information a').attr('href', variantUrl);
    }); */

    // Variant image change
    $(document).on('click', '.product_tab_variants label', function() {
      var selected_image = $(this).attr('variant-src');
      var variantUrl = $(this).attr('data-variant');
      var variantSrcSet = $(this).attr('variant-srcset');
      $(this).closest('.product_tab_columns').find('.product_tab_image img').attr('src', selected_image);
      $(this).closest('.product_tab_columns').find('.product_tab_image img').attr('srcset', variantSrcSet);
      $('.product_tab_image a').attr('href', variantUrl);
      $('.product_tab_information a').attr('href', variantUrl);
    });

    // initSlickSliders();

    // Reinit on Shopify section load (optional)
    // document.addEventListener('shopify:section:load', initSlickSliders);
    

    /* setTimeout(function() {
        var menu = jQuery('.nb_mega-menu');
        var liOffset = menu.closest('li').offset().left;
        var deviceWidth = $(window).width();
        
        menu.css({
            width: deviceWidth + 'px',
            left: -liOffset + 'px'
        });
        menu.removeClass('nb_d-none');
      
    }, 500); */

    setTimeout(function() {
      var menu = jQuery('.nb_mega-menu');
      var liOffset = menu.closest('li').offset().left;
      var deviceWidth = $(window).width();

      if(liOffset){
        liOffset = (liOffset - 20);
      }
      
      menu.css({
          width: deviceWidth + 'px',
          left: -liOffset + 'px'
      });
      menu.removeClass('nb_d-none');
      
    }, 500);
/*
// mega menu active
  // Click handler for the toggle link
  $('.mega-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Stop bubbling to document

    const $menuLink = $(this).closest('.menu-link');

    // Toggle class on this menu item only
    $('.menu-link').not($menuLink).removeClass('nb_mega_submenu_active'); // Close others
    $menuLink.toggleClass('nb_mega_submenu_active');
  });

  // Prevent closing when clicking inside the mega menu
  $('.nb_mega-menu').on('click', function (e) {
    e.stopPropagation();
  });

  // Click anywhere else closes the menu
  $(document).on('click', function () {
    $('.menu-link').removeClass('nb_mega_submenu_active');
  });    
// mega menu active
*/

  });

})(jQuery);
